/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CursorPaginationDto } from '../../models/cursor-pagination-dto';
import { MarketingConsentDto } from '../../models/marketing-consent-dto';

export interface MarketingConsentControllerSearchCursorV1$Params {

/**
 * 페이지 크기
 */
  pageSize?: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 커서
 */
  cursor?: string;

/**
 * 마케팅 동의 여부
 */
  isAgreed?: boolean;

/**
 * 브랜드
 */
  brandType?: 'MILLIONSHOW' | 'GOODSPACE' | 'ALLHOUSE' | 'STARTFAIR' | 'AGRITEX' | 'GIFTFAIR';
}

export function marketingConsentControllerSearchCursorV1(http: HttpClient, rootUrl: string, params?: MarketingConsentControllerSearchCursorV1$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto & {
'items'?: Array<MarketingConsentDto>;
}>> {
  const rb = new RequestBuilder(rootUrl, marketingConsentControllerSearchCursorV1.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('cursor', params.cursor, {});
    rb.query('isAgreed', params.isAgreed, {});
    rb.query('brandType', params.brandType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CursorPaginationDto & {
      'items'?: Array<MarketingConsentDto>;
      }>;
    })
  );
}

marketingConsentControllerSearchCursorV1.PATH = '/api/v1/marketing-consent/search/cursor';
